import useConstructor from "./useConstructor";
import useDestructor from "./useDestructor";

const usePaymentDrawTonightLifeCycle = () => {
  useConstructor();
  useDestructor();
};

export default usePaymentDrawTonightLifeCycle;
